import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect, useLocation } from "react-router-dom";
import Requestimates from "./components/views/requestimates/requestimates";
import Campaigns from "./components/views/campaigns/Campaigns";
import Referrals from "./components/views/referrals/referrals";
import RequestimateForm from "./components/views/requestimates/requestimateForm";
import NavBar from "./components/partial/navBar";
import NavTop from "./components/partial/navTop";
import NavTopBar from "./components/partial/navTopBar";
import Calendar from "./components/views/calendar/calendar";
import Financials from "./components/views/financials/newFinancials";
import Vehicles from "./components/newVehicles";
import Customers from "./components/views/customer/newCustomers";
import Services from "./components/views/services/newServices";
import InventoryDashboard from "./components/views/inventory/InventoryDashboard";
import WalkInForm from "./components/views/requestimates/walkInForm";
import Users from "./components/Users";
import Profile from "./components/views/profile/ProfilePage";
import CheckInWizard from './components/views/checkin/CheckInWizard';
import StaffManagement from './components/views/staff/StaffManagement';
import StaffTimeDetail from './components/views/staff/StaffTimeDetail';
import TimeReports from './components/views/staff/TimeReports';
import MyWork from './components/views/technician/MyWork';
import MyTime from './components/views/technician/MyTime';
import History from './components/views/history/History';
import Dashboard from './components/views/dashboard/Dashboard';
import TodayView from './components/views/today/TodayView';
import Tasks from './components/views/tasks/Tasks';
import VendorDetail from './components/views/vendors/VendorDetail';
import PurchasingDashboard from './components/views/purchasing/PurchasingDashboard';
import PODetail from './components/views/purchasing/PODetail';
import POCreate from './components/views/purchasing/POCreate';

// NEW: Import claim components for public routes
import ClaimPage from "./components/views/claim/ClaimPage";
import ClaimReferralPage from "./components/views/claim/ReferralClaimForm";
import PublicReferralForm from "./components/views/referrals/PublicReferralForm";
import DealerSignup from "./components/views/auth/DealerSignup";
import DealerWelcome from "./components/views/auth/DealerWelcome";
import EstimateChatbot from "./components/views/estimates/EstimateChatbot";
import PublicQuoteAccept from "./components/views/quotes/PublicQuoteAccept";
import Unsubscribe from "./components/views/unsubscribe/Unsubscribe";

import OBDPanel from "./components/partial/OBDPanel";

import "./assets/css/App.css";
import ReactGA from "react-ga4";
import VersionChecker from "./components/partial/VersionChecker";
import MaintenanceWatcher from "./components/partial/MaintenanceWatcher";
import TermsAcceptanceModal from "./components/partial/TermsAcceptanceModal";
import packageJson from "../package.json";
import { HTTPService } from "./services/httpService";
import { TermsAPI } from "./services/termsService";
import ScopeService from "./services/scopeService";
import { ALL_DEALERSHIPS_ID } from "./util/locationUtils";
import { Auth } from "aws-amplify";
import EditJob from "./components/views/requestimates/editJob";
import ContractForm from "./components/views/requestimates/contractForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const API = new HTTPService();

const RELEASE_NOTES_URL = "https://s3.us-east-2.amazonaws.com/jobvious.digitalassets/Jobvious_Release_Notes.pdf";

const PAGE_TITLES = {
  '/requestimates': 'Requests',
  '/jobs': 'Jobs',
  '/pickups': 'Pickups',
  '/reviews': 'Reviews',
  '/calendar': 'Calendar',
  '/financials': 'Financials',
  '/today': 'Today',
  '/dashboard': 'Dashboard',
  '/history': 'History',
  '/profile': 'Profile',
  '/services': 'Services',
  '/vehicles': 'Vehicles',
  '/customers': 'Customers',
  '/referrals': 'Referrals',
  '/campaigns': 'Campaigns',
  '/inventory': 'Inventory',
  '/staff': 'Staff',
  '/tasks': 'Reminders',
  '/purchasing': 'Purchasing',
  '/purchase-orders': 'Purchase Orders',
  '/vendors': 'Vendors',
  '/mywork': 'My Work',
  '/mytime': 'My Time',
  '/users': 'Users',
  '/newrequestimates': 'New Request',
  '/newestimate': 'Walk-In',
  '/editJob': 'Edit Job',
  '/estimate': 'Estimate',
  '/checkin': 'Check-In',
};

const PageTitle = () => {
  const location = useLocation();
  React.useEffect(() => {
    const path = location.pathname;
    const match = Object.keys(PAGE_TITLES).find(key => path.startsWith(key));
    const pageTitle = match ? PAGE_TITLES[match] : 'Jobvious';
    document.title = `${pageTitle} | Jobvious`;
    ReactGA.send({ hitType: 'pageview', page: path, title: pageTitle });
  }, [location.pathname]);
  return null;
};

const UpdateToast = () => {
  React.useEffect(() => {
    const updatedVersion = localStorage.getItem("jobvious_updated_version");
    if (updatedVersion) {
      localStorage.removeItem("jobvious_updated_version");
      toast.info(
        <div>
          <strong>Updated to v{updatedVersion}</strong>
          <br />
          <span
            onClick={() => window.open(RELEASE_NOTES_URL, "_blank")}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Click to read the Release Notes
          </span>
        </div>,
        { autoClose: 10000 }
      );
    }
  }, []);
  return null;
};

require("dotenv").config();

class App extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props, context) {
    super(props, context);
  }


  state = (() => {
    // Read location state synchronously so the first render has correct values
    let locations = [];
    let selectedLocationId = null;
    let selectedDealerId = ALL_DEALERSHIPS_ID;
    try {
      const company = JSON.parse(localStorage.getItem('companyAPI'));
      if (company && company.locations) {
        locations = company.locations;
        selectedLocationId = company.selectedLocationId || null;
      }
    } catch { /* no-op */ }

    // Technicians need a concrete current location — they're always working
    // at one site at a time, and MyWork branches on currentLocation.installer_type
    // to render mobile RouteView vs fixed shop view. Owners/admins are allowed
    // to leave it null ("All Locations") for cross-location dashboards, but a
    // null on a tech leaves them stuck on the fixed view with no work.
    // Default-pick the first location and persist it so reloads stay sticky.
    try {
      const user = JSON.parse(localStorage.getItem('userAPI') || 'null');
      const isTechnician = user && (user.role || '').toLowerCase() === 'technician';
      if (isTechnician && !selectedLocationId && locations.length > 0) {
        // Prefer a mobile location if one exists — techs assigned to multiple
        // locations typically have a mobile crew as their primary work site.
        // Fixed-only techs fall through to the first overall.
        const mobileLoc = locations.find(l => l.installer_type === 'mobile');
        selectedLocationId = (mobileLoc || locations[0]).location_id;
        const company = JSON.parse(localStorage.getItem('companyAPI') || '{}');
        company.selectedLocationId = selectedLocationId;
        localStorage.setItem('companyAPI', JSON.stringify(company));
      }
    } catch { /* no-op */ }

    try {
      const dgInfo = JSON.parse(localStorage.getItem('dealerGroupAPI'));
      if (dgInfo) {
        const val = dgInfo.selectedDealerId;
        // Legacy 0/'0' coerced to 'all' to match the new string sentinel
        if (val === undefined || val === null || val === 0 || val === '0') {
          selectedDealerId = ALL_DEALERSHIPS_ID;
        } else {
          selectedDealerId = val;
        }
      }
    } catch { /* no-op */ }
    return {
      selectedRequest: "",
      sidebarCollapsed: false,
      locations,
      selectedLocationId,
      selectedDealerId,
      obdPanelOpen: false,
      termsCheck: { status: 'loading', current: null },
    };
  })();

  componentDidMount() {
    window.addEventListener('sidebarToggled', this.handleSidebarToggle);
    window.addEventListener('companyLocationsUpdated', this.handleCompanyLocationsUpdated);
    this.checkTermsStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.authState !== this.props.authState && this.props.authState === 'signedIn') {
      this.checkTermsStatus();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('sidebarToggled', this.handleSidebarToggle);
    window.removeEventListener('companyLocationsUpdated', this.handleCompanyLocationsUpdated);
  }

  handleCompanyLocationsUpdated = (event) => {
    // Re-read locations + selectedLocationId from localStorage (ProfilePage
    // already wrote them) and push to state so the selector and any
    // location-aware children re-render.
    const fromEvent = event?.detail?.locations;
    let locations = fromEvent || [];
    let selectedLocationId = this.state.selectedLocationId;
    try {
      const company = JSON.parse(localStorage.getItem('companyAPI'));
      if (company) {
        if (!fromEvent && Array.isArray(company.locations)) locations = company.locations;
        if (company.selectedLocationId) selectedLocationId = company.selectedLocationId;
      }
    } catch { /* no-op */ }
    this.setState({ locations, selectedLocationId });
  };

  checkTermsStatus = async () => {
    if (this.props.authState !== 'signedIn') return;
    const user = JSON.parse(localStorage.getItem('userAPI') || 'null');
    if (!user || !user.User_id) return;
    this.setState({ termsCheck: { status: 'loading', current: null } });
    try {
      const result = await TermsAPI.getStatus(user.User_id);
      const data = (result && result.data) || {};
      if (!data.current || data.accepted) {
        this.setState({ termsCheck: { status: 'ok', current: null } });
      } else {
        this.setState({ termsCheck: { status: 'pending', current: data.current } });
      }
    } catch (err) {
      toast.error('Could not verify Terms & Conditions status. You may be re-prompted next session.');
      this.setState({ termsCheck: { status: 'ok', current: null } });
    }
  };

  handleTermsAccepted = () => {
    this.setState({ termsCheck: { status: 'ok', current: null } });
  };

  handleTermsDeclined = async () => {
    try {
      await Auth.signOut();
    } catch { /* no-op */ }
    localStorage.clear();
    window.location = '/';
  };

  handleSidebarToggle = (event) => {
    this.setState({ sidebarCollapsed: event.detail.collapsed });
  };

  handleOBDToggle = () => {
    this.setState(prev => ({ obdPanelOpen: !prev.obdPanelOpen }));
  };

  handleLocationChange = (locationId) => {
    // Update localStorage then reload so all components re-fetch for the new location
    try {
      const company = JSON.parse(localStorage.getItem('companyAPI'));
      if (company) {
        company.selectedLocationId = locationId;
        localStorage.setItem('companyAPI', JSON.stringify(company));
      }
    } catch { /* no-op */ }

    window.location.reload();
  };

  // Switch to a different scope (different installer or dealer group).
  // The selector passes the scope index from scopeService.getAllScopes().
  // Optional targetSubId narrows within the new scope (location_id for installer,
  // dealer_id for dealer).
  handleSwitchScope = async (scopeIndex, targetSubId = null) => {
    const scope = await ScopeService.activateScopeByIndex(scopeIndex);

    // Stripe capabilities — only meaningful for installer-side scopes
    if (scope.type === 'installer') {
      try {
        const stripeRes = await API.get(`/api/installers/${scope.id}/stripe-status`);
        localStorage.setItem("stripeCapabilities", JSON.stringify(stripeRes.data || {}));
      } catch {
        localStorage.setItem("stripeCapabilities", JSON.stringify({}));
      }
    } else {
      localStorage.setItem("stripeCapabilities", JSON.stringify({}));
    }

    // Apply sub-scope target if provided
    if (targetSubId !== null) {
      if (scope.type === 'installer') {
        const valid = (scope.locations || []).find(l => String(l.location_id) === String(targetSubId));
        if (valid) ScopeService.setSelectedLocationId(targetSubId);
      } else if (scope.type === 'dealer') {
        ScopeService.setSelectedDealerId(targetSubId);
      }
    }

    // named_user_id slug for legacy storage keys
    const slug = (scope.name || '').replace(/ /g, '_').toLowerCase();
    localStorage.setItem("named_user_id", JSON.stringify(slug));

    // Land on the role-appropriate home. Finance users on a dealer-group scope
    // (full group access, location_id = 0) start in financials.
    const role = (ScopeService.getUserRole() || '').toLowerCase();
    const dest = (scope.type === 'dealer' && ScopeService.isDealerGroupUser() && role === 'finance')
      ? '/financials'
      : '/requestimates';
    window.location = dest;
  };

  handleRequest = async (request) => {
    this.setState({ selectedRequest: request });
  };


isPublicRoute = () => {
  const path = window.location.pathname;
  const publicPaths = ['/referralclaim', '/claim', '/public/referral', '/signup/dealer', '/welcome', '/estimate', '/unsubscribe'];
  return publicPaths.some(p => path.startsWith(p));
};

// Here's a much cleaner approach - just modify your existing render method:

render() {
  ReactGA.initialize(process.env.REACT_APP_GA);

  setTimeout(() => {
    // Checks if login process has finished, if not, returns to login
    if (
      (!window.localStorage.getItem("userAPI") ||
        !window.localStorage.getItem("companyAPI")) &&
      window.localStorage.getItem("amplify-authenticator-authState") ===
        "signedIn"
    ) {
      window.localStorage.clear();
      window.location.reload();
    }
  }, 5000);

  const user = JSON.parse(localStorage.getItem("userAPI"));
  const company = JSON.parse(localStorage.getItem("companyAPI"));

  return (
    <React.Fragment>
      <BrowserRouter>
        <PageTitle />
        <VersionChecker />
        <UpdateToast />
        <ToastContainer position="top-right" autoClose={8000} />
        <div className="App">
          <MaintenanceWatcher />
          <Switch>
            {/* PUBLIC ROUTES FIRST - No authentication required */}
            <Route path="/claim" component={ClaimPage} />
            <Route path="/referralclaim" component={ClaimReferralPage} />
            <Route path="/public/referral" component={PublicReferralForm} />
            <Route path="/quote/:requestId/accept/:token" component={PublicQuoteAccept} />
            <Route path="/signup/dealer" component={DealerSignup} />
            <Route path="/welcome" component={DealerWelcome} />
            <Route path="/estimate" component={EstimateChatbot} />
            <Route path="/unsubscribe/:token" component={Unsubscribe} />
            
            {/* AUTHENTICATED ROUTES - All other routes require authentication */}
            <Route 
              path="/"
              render={(props) => {
                // Check if user is authenticated
                if (this.props.authState === "signedIn" && user && company) {
                  // Terms & Conditions gate — block app UI until current terms are accepted
                  const { termsCheck } = this.state;
                  if (termsCheck.status === 'loading') {
                    return (
                      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    );
                  }
                  if (termsCheck.status === 'pending') {
                    return (
                      <TermsAcceptanceModal
                        current={termsCheck.current}
                        userId={user.User_id}
                        onAccepted={this.handleTermsAccepted}
                        onDeclined={this.handleTermsDeclined}
                      />
                    );
                  }

                  let companyName = "";
                  let typeId = "";
                  let capacity = 0;
                  let authenticated = 0;
                  let userCalendar = "";
                  const dealerGroupInfo = JSON.parse(localStorage.getItem("dealerGroupAPI") || "null");
                  // company_type is now ONLY 'installer' or 'dealer'. Full-group vs single-dealer
                  // access for dealer users is derived from dealerGroupInfo.isDealerGroup
                  // (server-side: user_companies.location_id === 0).
                  const userType = user.User_type;
                  const isDealerGroup = Boolean(dealerGroupInfo && dealerGroupInfo.isDealerGroup);
                  if (userType === "dealer") {
                    companyName = dealerGroupInfo ? (dealerGroupInfo.groupName || company.dealer_name) : company.dealer_name;
                    typeId = company.dealer_id;
                  } else {
                    companyName = company.Installer_Name;
                    typeId = company.Installer_id;
                    capacity = company.capacity;
                    authenticated = company.Authenticated;
                    userCalendar = company.calendar_id;
                  }

                  const selectedReferral = {};

                  // Multi-location props
                  const locations = this.state.locations;
                  const selectedLocationId = this.state.selectedLocationId;
                  const currentLocation = (locations || []).find(
                    l => String(l.location_id) === String(selectedLocationId)
                  ) || null;
                  const selectedDealerId = this.state.selectedDealerId;
                  const groupId = dealerGroupInfo ? dealerGroupInfo.groupId : null;

                  // Dealer role access helpers
                  const dealerRole = (user.role || '').toLowerCase();
                  const isDealerContact = userType === 'dealer' && dealerRole === 'contact';

                  return (
                    <div className="container-fluid">
                      <div className="row">
                        {/* Mobile */}
                        <div className="col-lg-12 d-lg-none p-0">
                          <NavTopBar
                            title={companyName}
                            userType={userType}
                            userId={user.User_id}
                            userName={user.user_name}
                            access={user.access}
                            userRole={user.role}
                            onSwitch={this.handleSwitchScope}
                            locations={locations}
                            selectedLocationId={selectedLocationId}
                            onLocationChange={this.handleLocationChange}
                            selectedDealerId={selectedDealerId}
                            groupId={groupId}
                          />
                        </div>

                        {/* Display LG */}
                        <div className={`bg-sidebar p-0 d-none d-lg-block ${this.state.sidebarCollapsed ? 'sidebar-col-collapsed' : 'col-lg-2'}`}>
                          <NavBar
                            userType={userType}
                            userId={user.User_id}
                            access={user.access}
                            userRole={user.role}
                            entityId={typeId}
                            authenticated={authenticated}
                            selectedLocationId={selectedLocationId}
                            selectedDealerId={selectedDealerId}
                            groupId={groupId}
                            {...this.props}
                          />
                        </div>

                        <div className={`p-0 wrapper ${this.state.sidebarCollapsed ? 'content-col-expanded' : 'col-lg-10'}`}>
                          <NavTop
                            title={companyName}
                            userId={user.User_id}
                            userName={user.user_name}
                            access={user.access}
                            onSwitch={this.handleSwitchScope}
                            userType={userType}
                            userRole={user.role}
                            locations={locations}
                            selectedLocationId={selectedLocationId}
                            onLocationChange={this.handleLocationChange}
                            selectedDealerId={selectedDealerId}
                            groupId={groupId}
                            showOBD={this.state.obdPanelOpen}
                            onOBDToggle={this.handleOBDToggle}
                          />

                          {userType === 'installer' && (
                            <OBDPanel
                              show={this.state.obdPanelOpen}
                              onClose={() => this.setState({ obdPanelOpen: false })}
                              installerId={typeId}
                              locationId={selectedLocationId}
                            />
                          )}

                          <div className="p-2">
                            {/* Dealer contact role: no page access */}
                            {isDealerContact ? (
                              <div className="text-center py-5">
                                <i className="fa-sharp fa-regular fa-lock fa-3x text-muted mb-3 d-block"></i>
                                <h5>No Access</h5>
                                <p className="text-muted">Your account is set up as a contact only. Please speak to your manager for access.</p>
                              </div>
                            ) : (
                            <Switch>
                              <Route
                                path="/settings/qbo"
                                render={({ location }) => {
                                  const params = new URLSearchParams(location.search);
                                  if (params.get('connected')) {
                                    return <Redirect to="/profile?qbo_connected=true" />;
                                  }
                                  if (params.get('error')) {
                                    return <Redirect to={`/profile?qbo_error=${encodeURIComponent(params.get('message') || 'Connection failed')}`} />;
                                  }
                                  return <Redirect to="/profile" />;
                                }}
                              />
                              <Route
                                path="/profile"
                                render={(props) => (
                                  <Profile
                                    userType={userType}
                                    userRole={user.role}
                                    access={user.access}
                                    userId={user.User_id}
                                    entityId={typeId}
                                    typeId={typeId}
                                    authenticated={authenticated}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />

                              <Route
                                path="/campaigns"
                                render={(props) => (
                                  <Campaigns
                                    user={user}
                                    userType={userType}
                                    typeId={typeId}
                                    access={user.access}
                                    authenticated={authenticated}
                                    company={company}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/calendar"
                                render={(props) => {
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Calendar
                                      userType={userType}
                                      typeId={typeId}
                                      authenticated={authenticated}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/financials"
                                render={(props) => {
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Financials
                                      userType={userType}
                                      user={user}
                                      access={user.access}
                                      typeId={typeId}
                                      company={company}
                                      groupId={groupId}
                                      groupName={dealerGroupInfo ? dealerGroupInfo.groupName : null}
                                      selectedDealerId={selectedDealerId}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/today"
                                render={(props) => (
                                  <TodayView
                                    userType={userType}
                                    user={user}
                                    typeId={typeId}
                                    company={company}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/tasks"
                                render={(props) => (
                                  <Tasks
                                    userType={userType}
                                    user={user}
                                    typeId={typeId}
                                    company={company}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/dashboard"
                                render={(props) => {
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Dashboard
                                      userType={userType}
                                      user={user}
                                      typeId={typeId}
                                      company={company}
                                      groupId={groupId}
                                      selectedDealerId={selectedDealerId}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/history"
                                render={(props) => {
                                  // Only allow managers/owners, not technicians
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <History
                                      userType={userType}
                                      user={user}
                                      entityId={typeId}
                                      company={company}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/requests/:requestId/checkin"
                                render={(props) => (
                                  <CheckInWizard
                                    company={company}
                                    user={user}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    currentLocation={currentLocation}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/customers"
                                render={(props) => (
                                  <Customers
                                    userType={userType}
                                    typeId={typeId}
                                    userRole={user.role}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/services"
                                render={(props) => {
                                  if (userType === 'installer' && ['viewer', 'technician'].includes(user.role)) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <Services
                                      userType={userType}
                                      typeId={typeId}
                                      access={user.access}
                                      user={user}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              {/* ReceiveInventory is now a modal — opened from InventoryDashboard and PODetail */}
                              <Route
                                path="/inventory"
                                render={(props) => {
                                  // Viewers cannot access inventory
                                  if (userType === 'installer' && user.role === 'viewer') {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <InventoryDashboard
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/vendors/:id"
                                render={(props) => {
                                  // Purchasing: installer admin only
                                  if (userType !== 'installer' || (user.access !== 'ADMIN' && user.role !== 'admin' && user.role !== 'owner')) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <VendorDetail
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/vendors"
                                exact
                                render={() => <Redirect to="/purchasing?tab=vendors" />}
                              />
                              <Route
                                path="/purchase-orders/new"
                                render={(props) => {
                                  if (userType !== 'installer' || (user.access !== 'ADMIN' && user.role !== 'admin' && user.role !== 'owner')) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <POCreate
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/purchase-orders/:id"
                                render={(props) => {
                                  if (userType !== 'installer' || (user.access !== 'ADMIN' && user.role !== 'admin' && user.role !== 'owner')) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <PODetail
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/purchase-orders"
                                exact
                                render={() => <Redirect to="/purchasing" />}
                              />
                              <Route
                                path="/purchasing"
                                render={(props) => {
                                  if (userType !== 'installer' || (user.access !== 'ADMIN' && user.role !== 'admin' && user.role !== 'owner')) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <PurchasingDashboard
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/staff/time-reports"
                                render={(props) => (
                                  <TimeReports
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/staff/:userId/time"
                                render={(props) => (
                                  <StaffTimeDetail
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/staff"
                                render={(props) => {
                                  // Staff page: installers must be admin, owner, or manager (legacy access === 'ADMIN' also qualifies)
                                  if (userType === 'installer' && user.access !== 'ADMIN' && !['admin', 'owner', 'manager'].includes(user.role)) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  // Dealer staff: only manager, admin, finance (legacy ADMIN access also qualifies)
                                  if (userType === 'dealer' && user.access !== 'ADMIN' && !['manager', 'admin', 'finance'].includes(dealerRole)) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <StaffManagement
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      companyName={companyName}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/mywork"
                                render={(props) => (
                                  <MyWork
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    companyName={companyName}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    currentLocation={currentLocation}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/mytime"
                                render={(props) => (
                                  <MyTime
                                    user={user}
                                    typeId={typeId}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/vehicles"
                                render={(props) => (
                                  <Vehicles
                                    userType={userType}
                                    typeId={typeId}
                                    userRole={user.role}
                                    access={user.access}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/users"
                                render={(props) => (
                                  <Users
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    {...props}
                                  />
                                )}
                              />
                              <Route path="/jobs"
                                render={(props) => {
                                  // Redirect technicians to their My Work view
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Requestimates
                                      mode="jobs"
                                      userType={userType}
                                      user={user}
                                      companyName={companyName}
                                      company={company}
                                      authenticated={authenticated}
                                      calendar={userCalendar}
                                      typeId={typeId}
                                      groupId={groupId}
                                      selectedDealerId={selectedDealerId}
                                      selectRequest={this.handleRequest}
                                      selectedRequest={this.state.selectedRequest}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      currentLocation={currentLocation}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/pickups"
                                render={(props) => (
                                  <Requestimates
                                    mode="pickups"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    groupId={groupId}
                                    selectedDealerId={selectedDealerId}
                                    selectRequest={this.handleRequest}
                                    selectedRequest={this.state.selectedRequest}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    currentLocation={currentLocation}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/reviews"
                                render={(props) => (
                                  <Requestimates
                                    mode="reviews"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    groupId={groupId}
                                    selectedDealerId={selectedDealerId}
                                    selectRequest={this.handleRequest}
                                    selectedRequest={this.state.selectedRequest}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    currentLocation={currentLocation}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/newrequestimates"
                                render={(props) => (
                                  <RequestimateForm
                                    userType={userType}
                                    user={user}
                                    userAccess={user.access}
                                    companyName={companyName}
                                    company={company}
                                    typeId={typeId}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    currentLocation={currentLocation}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/newestimate"
                                render={(props) => (
                                  <WalkInForm
                                    userType={userType}
                                    user={user}
                                    capacity={capacity}
                                    companyName={companyName}
                                    company={company}
                                    typeId={typeId}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    currentLocation={currentLocation}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/requestimates"
                                render={(props) => {
                                  // Redirect technicians to their My Work view
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Requestimates
                                      mode="requests"
                                      userType={userType}
                                      user={user}
                                      typeId={typeId}
                                      company={company}
                                      companyName={companyName}
                                      authenticated={authenticated}
                                      calendar={userCalendar}
                                      groupId={groupId}
                                      selectedDealerId={selectedDealerId}
                                      onSwitch={this.handleSwitchScope}
                                      selectRequest={this.handleRequest}
                                      selectedRequest={this.state.selectedRequest}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      currentLocation={currentLocation}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/referrals"
                                render={(props) => (
                                  <Referrals
                                    mode="referrals"
                                    userType={userType}
                                    user={user}
                                    typeId={typeId}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    selectedReferral={selectedReferral}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/editJob/:requestId"
                                render={(props) => (
                                  <EditJob
                                    mode="requests"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/contract/:requestId"
                                render={(props) => (
                                  <ContractForm
                                    mode="requests"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    {...props}
                                  />
                                )}
                              />
                              {/* Default route for authenticated users */}
                              {/* Dealer group → financials, Technicians → mywork, others → requestimates */}
                              <Route exact path="/" render={() => {
                                if (userType === 'dealer' && isDealerGroup) {
                                  const dgRole = (user.role || '').toLowerCase();
                                  if (dgRole === 'finance') return <Redirect to="/financials" />;
                                  return <Redirect to="/requestimates" />;
                                }
                                if (userType === 'installer' && user.role === 'technician') return <Redirect to="/mywork" />;
                                return <Redirect to="/requestimates" />;
                              }} />
                            </Switch>
                            )}
                          </div>

                          <div className="col-lg-12 mt-5 text-center">
                            <p>&copy; 2026 {user && (user.Email === 'installer@jobvious.com' || user.Email === 'dealer@jobvious.com') ? 'Powered by Jobvious' : 'Jobvious, Inc'} (v {packageJson.version}) </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              }}
            />
          </Switch>
        </div>
      </BrowserRouter>
    </React.Fragment>
  );
}
}
export default App;
